/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {setCurrentLocale} from '../../../common/intl/actions';

class LanguageSwitcher extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        currentLocale: React.PropTypes.string,
        setCurrentLocale: React.PropTypes.func
    };

    render() {
        const {currentLocale, setCurrentLocale, msg} = this.props;

        return (
            <div className="pageLogin-language">
                {msg.login.language}:&nbsp;
                {currentLocale !== 'cs' &&
                    <span onClick={() => setCurrentLocale('cs')} className="pageLogin-link">Čeština</span>
                }
                {currentLocale !== 'en' &&
                    <span onClick={() => setCurrentLocale('en')} className="pageLogin-link">English</span>
                }
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    currentLocale: state.intl.currentLocale
}), {setCurrentLocale})(LanguageSwitcher);



// WEBPACK FOOTER //
// ./src/browser/components/intl/LanguageSwitcher.js